import type { ProductRowHeights } from '../Carousel';

export const getTallestRowHeights = (
  rowHeights: ProductRowHeights,
  numberOfProducts: number,
) => {
  if (rowHeights && Object.entries(rowHeights).length === numberOfProducts) {
    // Once all cell heights are collected, compute the tallest heights
    const tallestHeights = Object.values(rowHeights).reduce((acc, heights) => {
      heights.forEach((height, index) => {
        // Update each column index with the tallest height across products
        if (height !== undefined) {
          acc[index] = Math.max(acc[index] || 0, height);
        }
      });
      return acc;
    }, [] as number[]);

    return tallestHeights;
  }

  return null;
};
